// extracted by mini-css-extract-plugin
export default {"recos":"J5-z","productCardOverride":"K5-z","rowHasBadge":"L5-z"};